import styled from 'styled-components'
import { media } from '@/theme/tokens'

export const TripsGrid = styled.div`
	display: grid;
	grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));
	gap: 24px;
	align-items: stretch;

	${media.phone} {
		grid-template-columns: 1fr;
		gap: 16px;
	}
`

